import * as React from 'react';

import FormRow from 'Components/FormRow';
import InputHandler from 'Components/InputHandler';
import ThemedDialog from 'Components/_NewElements/Dialog';
import { actions } from 'Store/documents/actions';
import { useAppDispatch } from 'Store/index';
import { dateFromPartial, isPartialDate, partialDateFromDate } from 'neuro-utils';
import { useIntl } from 'react-intl';

const partialFromIso = (ds?: string | null) => {
  if (!ds) return null;
  const date = new Date(ds);
  return partialDateFromDate(date);
};

const EditFileDialog = ({ editingFileData, onCloseEditing }: IOwnProps): React.JSX.Element => {
  const [newData, setNewData] = React.useState<Partial<Pick<TFile, 'date' | 'name' | 'subType' | 'referenceType'>>>({});

  const editFileData = (data: Record<string, string>) => {
    const editedData = data;
    newData && setNewData({ ...newData, ...editedData });
  };

  const dispatch = useAppDispatch();

  const { formatMessage } = useIntl();
  const fm = (id: string) => formatMessage({ id });
  return (
    <ThemedDialog
      open={!!editingFileData}
      title={fm('patientFiles.editFileData')}
      dialogActions={[
        {
          text: 'general.cancel',
          onClick: () => {
            onCloseEditing();
          },
          border: false,
        },
        {
          text: 'general.confirm',
          onClick: async () => {
            if (editingFileData) {
              if (newData && Object.keys(newData).length > 0) {
                void (await actions
                  .editFileMetadata(
                    editingFileData._id,
                    newData,
                  )(dispatch)
                  .then(res => {
                    setNewData({});
                    onCloseEditing();
                  }));
              }
            }
          },
        },
      ]}
    >
      <div>
        <FormRow title="general.date">
          <InputHandler
            editing
            type="PartialDate"
            name="date"
            formData={{
              document: { date: partialFromIso(newData?.['date']) ?? partialFromIso(editingFileData?.['date']) },
              onChange: values => {
                const value = values['date'];
                isPartialDate(value) && editFileData({ date: dateFromPartial(value).toISOString() });
              },
            }}
            isNotCancellable
          />
        </FormRow>

        <FormRow title="general.name">
          <InputHandler
            editing
            name="name"
            type="TextField"
            formData={{
              document: { name: newData?.['name'] ?? editingFileData?.['name'] },
              onChange: values => {
                const value = values['name'] as string;
                editFileData({ name: value });
              },
            }}
          />
        </FormRow>
      </div>
    </ThemedDialog>
  );
};

interface IOwnProps {
  editingFileData: TFile | null;
  onCloseEditing: () => void;
}

export default EditFileDialog;
